export const ACTION_ANIMATION_TIME = 300;
export const DEFAULT_MAX_TURNS_WITHOUT_ACTION = 20;
export const DEFAULT_MAX_FOLLOWING_TURNS = 4;
export const DEFAULT_TIME_PER_TURN = 60; // 60 seconds

const ATTACK = 'attack';
const MOVE = 'move';
const FLIP = 'flip';

export const GAME_ACTIONS = {
    ATTACK,
    MOVE,
    FLIP,
};

const AI_GAME = 'ai';
const LOCAL_GAME = 'local';
const ONLINE_GAME = 'online';
const RANKED_GAME = 'ranked';

export const GAME_MODES = {
    AI_GAME,
    LOCAL_GAME,
    ONLINE_GAME,
    RANKED_GAME,
};

const FULL_GAME = 'Full Game';
const MORE_PIECES = 'More Pieces';
const HIGHEST_PIECE = 'Highest Piece';
const LAST_ACTION = 'Last Action';
const OVER_TIME = 'Over Time';
const USER_QUIT = 'User Quit';

export const WINNING_TYPES = {
    FULL_GAME,
    MORE_PIECES,
    HIGHEST_PIECE,
    LAST_ACTION,
    OVER_TIME,
    USER_QUIT,
};

const TOO_SHORT = 'too short';
const SHORT_GAME = 'short';
const MEDIUM_GAME = 'medium';
const LONG_GAME = 'long';

export const GAME_LENGTHS = {
    TOO_SHORT,
    SHORT_GAME,
    MEDIUM_GAME,
    LONG_GAME,
};

const QUEUED = 'queued';
const STARTED = 'started';
const FINISHED = 'finished';

export const GAME_STATUSES = {
    QUEUED,
    STARTED,
    FINISHED,
}